import { Link } from 'react-router-dom';
import { Shield, Lock } from 'lucide-react';

const Footer = () => {
  const links = {
    product: [
      { label: 'Platform', href: '/platform' },
      { label: 'Solutions', href: '/solutions' },
      { label: 'Surgeon Console', href: '/surgeon' },
    ],
    company: [
      { label: 'About', href: '/company' },
      { label: 'Contact', href: 'mailto:hello@linkmedicalai.com' },
    ],
  };

  return (
    <footer className="bg-foreground border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-12 sm:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          {/* Brand */}
          <div className="col-span-2">
            <span className="text-2xl font-bold tracking-tight text-white mb-3 block">LINK</span>
            <p className="text-sm text-gray-400 mb-4 max-w-xs leading-relaxed">
              Intelligent revenue infrastructure for surgical practices.
            </p>
            <div className="flex flex-wrap items-center gap-3">
              <div className="flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-primary/10 border border-primary/20">
                <Shield className="h-3 w-3 text-primary" />
                <span className="text-[10px] text-primary font-medium">HIPAA</span>
              </div>
              <div className="flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-cta/10 border border-cta/20">
                <Lock className="h-3 w-3 text-cta" />
                <span className="text-[10px] text-cta font-medium">SOC 2</span>
              </div>
            </div>
          </div>

          {[
            { title: 'Product', items: links.product },
            { title: 'Company', items: links.company },
          ].map((group) => (
            <div key={group.title} className="col-span-1">
              <h4 className="text-xs font-semibold text-gray-300 uppercase tracking-wider mb-4">{group.title}</h4>
              <ul className="space-y-2">
                {group.items.map((link) => (
                  <li key={link.label}>
                    <Link to={link.href} className="text-sm text-gray-400 hover:text-white transition-colors">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-gray-500">
            © {new Date().getFullYear()} LINK Medical, Inc. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
